import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const RoleBasedRedirect: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect all users to sales page since dashboard has been removed
  return <Navigate to="/sales" replace />;
};

export default RoleBasedRedirect;